export var defaultProps = {
  heading: {
    type: 'body-single-line-sm-bold'
  },
  callout: {
    iconName: 'InfoIcon',
    state: 'lilac',
    version: 'fixed-padding'
  },
  button: {
    buttonType: 'primary',
    version: 'variable-width'
  }
};
export var fieldVariantData = {
  mobileNumber: {
    fieldId: 'mssidn',
    fieldType: 'INPUT',
    fieldData: {
      label: 'Mobile number*',
      placeholder: 'Enter mobile number',
      inputRegex: '^[6-9]{1}[0-9]*$',
      maxLength: 10,
      validationRegex: '^\\d{10}$'
    }
  },
  email: {
    fieldId: 'emailAddress',
    fieldType: 'INPUT',
    fieldData: {
      invalidMsgForValidationRegex: 'invalid email address',
      label: 'E-mail address',
      placeholder: 'Enter e-mail address',
      id: 'FamilyCreateRequestFormInputItem',
      validationRegex: '^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$'
    }
  },
  name: {
    fieldId: 'name',
    fieldType: 'INPUT',
    fieldData: {
      inputRegex: '^[a-zA-Z\\s]+$',
      id: 'FamilyCreateRequestFormInputItem',
      label: 'Name*',
      placeholder: 'Enter your full name',
      validationRegex: '^[a-zA-Z\\s]+$'
    }
  }
};